import cardConfig from 'molecules/ImageCard/config';

import type { Input } from '@builder.io/sdk';

const imageCardFields = [
  {
    name: 'enableNegativeMargin',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'cards',
    type: 'list',
    subFields: cardConfig.inputs,
  },
] as const satisfies DeepReadonly<Input[]>;

const imageCardsConfig = {
  name: 'Image Cards',
  inputs: imageCardFields,
};

export type ImageCardsProps = GenerateBuilder<typeof imageCardFields>;

export default imageCardsConfig;
